<div class="form-metrics-widget" *ngIf="item">
  <h6 class="widget-title">{{ item.label }}</h6>
  <p class="widget-meta text-muted mb-1">{{ item.totalAnswers }} resposta(s)</p>

  <ng-container *ngIf="item.totalAnswers > 0 && chartOptions; else empty">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [colors]="chartOptions.colors"
      [stroke]="chartOptions.stroke"
      [xaxis]="chartOptions.xaxis"
      [grid]="chartOptions.grid"
      [dataLabels]="chartOptions.dataLabels"
      [tooltip]="chartOptions.tooltip"
      [noData]="chartOptions.noData">
    </apx-chart>
  </ng-container>

  <ng-template #empty>
    <p class="text-muted text-center py-3 mb-0">Sem respostas no período selecionado.</p>
  </ng-template>
</div>
